module.exports = __webpack_public_path__ + "static/media/ObjectCounter.9812c83d.jpg";